import { render, staticRenderFns } from "./kompetensbaserad-rekrytering.vue?vue&type=template&id=61d02418&"
import script from "./kompetensbaserad-rekrytering.vue?vue&type=script&lang=ts&"
export * from "./kompetensbaserad-rekrytering.vue?vue&type=script&lang=ts&"
import style0 from "./kompetensbaserad-rekrytering.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./kompetensbaserad-rekrytering.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VImg,VRow})
